export const POSTER_CAROUSEL_FIELD = {
    id: 'poster-carousel',
    name: 'Carousel',
    type: 'carousel',
    category: 'displayImages',
    readOnly: true
};

export const getCustomFieldTypes = (qrType) => {
    if (['liquid-poster', 'for-sale'].includes(qrType)) {
        return {
            [POSTER_CAROUSEL_FIELD.id]: POSTER_CAROUSEL_FIELD
        };
    }

    return {};
};
